import { render, staticRenderFns } from "./McuFasilitas.vue?vue&type=template&id=4d055a06"
import script from "./McuFasilitas.vue?vue&type=script&lang=js"
export * from "./McuFasilitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports